// GENERATED FILE - DO NOT MODIFY

export enum AccessTokenGrantType {
    password = "password",
    refresh_token = "refresh_token",
}